module.exports = __webpack_public_path__ + "img/flat-bed-scanner-extended-right.e4b6741e.svg";